import { useState } from 'react'

//mui
import {
  Box,
  Button,
  ButtonGroup,
  Grid,
  TextField,
  Modal,
  CircularProgress,
  Skeleton,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material'

// css
import './approval.css'

// css
import '../../auth/signup/components/payment/payment.css'
import visalogo from '../../../assets/VISA-Logo.png'
import mastercardlogo from '../../../assets/Mastercard-Logo.png'
import americanexpresslogo from '../../../assets/American-Express.png'

// icons
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'

// usenavigation
import { useNavigate, useSearchParams } from 'react-router-dom'

// api
import {
  approveorrejectcustomer,
  approveorrejectreseller,
  companyApproval,
} from '../../../api/post/postApi'

import jwt_decode from 'jwt-decode'
import { useSelector } from 'react-redux'
import {
  homeSliceState,
  setDirectCustomersList,
  setIsToggleCustomer,
  setIsToggleReseller,
  setIsToggleServiceProvider,
  setResellersList,
  setResellerTrigger,
  setServiceProvidersList,
  setServiceProviderTrigger,
} from '../../../store/slice/homeSlice'
import {
  checkPermission,
  normalizeApiResponse,
} from '../../../helpers/HelperFunctions'
import { COMPANY_LEVELS, COMPANY_STATUS } from '../../../helpers/Constants'
import { useCommonRedux } from '../../../store/middlewares/CommonRedux'
import { useHomeRedux } from '../Home'
import { useToastContext } from '../../../App'

export default function Approvalcompany(props) {
  const [searchParams] = useSearchParams()
  const { dispatch, state: commonState } = useCommonRedux()
  const { state: homeState } = useHomeRedux()
  const { toast } = useToastContext()
  const navigate = useNavigate()

  const state = useSelector(homeSliceState)

  // loading hooks
  const [approveloader, setapproveloader] = useState(false)
  const [rejectloader, setrejectapproval] = useState(false)

  const [approvalformType, setapprovalfromType] = useState('accountdetails')
  const approvalforms = (approvalformType) => {
    switch (approvalformType) {
      case 'accountdetails':
        return accountdetails()
      case 'companydetails':
        return companydetails()
      case 'billingcontact':
        return Billinginfo()
      case 'billinginfo':
        return BillingAddress()
      case 'paymentmethod':
        return paymentForm()
      case 'appearance':
        return appearance()
      case 'billingtype':
        return billingForm()
    }
  }
  const accountdetails = () => {
    return (
      <>
        <div className="approvalpage_formcontainer_fieldstyle">
          <Grid container rowSpacing={2} columnSpacing={2}>
            <Grid item md={12} sm={12} xs={12}>
              {props?.accountdetailsdata.email ? (
                <>
                  {' '}
                  <span>Email</span>
                  <TextField
                    fullWidth
                    value={props?.accountdetailsdata.email}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                  />
                </>
              ) : (
                <Skeleton
                  variant="rectangular"
                  sx={{ borderRadius: '5px' }}
                  height="56px"
                  width="100%"
                ></Skeleton>
              )}
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              {props?.accountdetailsdata.firstName ? (
                <>
                  {' '}
                  <span>Firstname</span>
                  <TextField
                    fullWidth
                    value={props?.accountdetailsdata.firstName}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                  />
                </>
              ) : (
                <Skeleton
                  variant="rectangular"
                  sx={{ borderRadius: '5px' }}
                  height="56px"
                  width="100%"
                ></Skeleton>
              )}
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              {props?.accountdetailsdata.firstName ? (
                <>
                  <span>Lastname</span>
                  <TextField
                    fullWidth
                    value={props?.accountdetailsdata.lastName}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                  />
                </>
              ) : (
                <Skeleton
                  variant="rectangular"
                  sx={{ borderRadius: '5px' }}
                  height="56px"
                  width="100%"
                ></Skeleton>
              )}
            </Grid>
            <Grid item md={10} sm={10} xs={10}>
              {props?.accountdetailsdata.firstName ? (
                <>
                  <span>Phone</span>
                  <TextField
                    fullWidth
                    value={props?.accountdetailsdata.phone}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                  />
                </>
              ) : (
                <Skeleton
                  variant="rectangular"
                  sx={{ borderRadius: '5px' }}
                  height="56px"
                  width="100%"
                ></Skeleton>
              )}
            </Grid>
            <Grid item md={2} sm={2} xs={2}>
              {props?.accountdetailsdata.firstName ? (
                <>
                  <span>Ext</span>
                  <TextField
                    fullWidth
                    value={props?.accountdetailsdata.extNumber}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                  />{' '}
                </>
              ) : (
                <Skeleton
                  variant="rectangular"
                  sx={{ borderRadius: '5px' }}
                  height="56px"
                  width="100%"
                ></Skeleton>
              )}
            </Grid>
          </Grid>
        </div>
      </>
    )
  }

  const companydetails = () => {
    return (
      <>
        <div className="approvalpage_formcontainer_fieldstyle">
          <Grid container rowSpacing={2} columnSpacing={2}>
            <Grid item md={12} sm={12} xs={12}>
              <span>Company Name</span>
              <TextField
                fullWidth
                value={props.companydetails.companyName}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
              <span>Address - Line 1</span>
              <TextField
                fullWidth
                value={props.companydetails.streetNumber}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
              <span>Address - Line 2</span>
              <TextField
                fullWidth
                value={
                  props.companydetails.street == null
                    ? ''
                    : props.companydetails.street
                }
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
              <span>city</span>
              <TextField
                fullWidth
                value={props.companydetails.city}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
              <span>State</span>
              <TextField
                fullWidth
                value={props.companydetails.state}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={8} sm={8} xs={8}>
              <span>Country</span>
              <TextField
                fullWidth
                value={props.companydetails.country}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={4} sm={4} xs={4}>
              <span>Zip</span>
              <TextField
                fullWidth
                value={props.companydetails.zip}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={8} sm={8} xs={8}>
              <span>Phone</span>
              <TextField
                fullWidth
                value={props.companydetails.phone}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={4} sm={4} xs={4}>
              <span>Fax</span>
              <TextField
                fullWidth
                value={props.companydetails.fax}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </div>
      </>
    )
  }

  const Billinginfo = () => {
    return (
      <div className="approvalpage_formcontainer_fieldstyle">
        <Grid container columnSpacing={2} rowSpacing={2}>
          <Grid item md={12} sm={12} xs={12}>
            <span>Email</span>
            <TextField
              fullWidth
              value={props.billingcontact.email}
              InputProps={{ readOnly: true }}
              variant="outlined"
            />
          </Grid>

          <Grid item md={6} sm={6} xs={6}>
            <span>First Name</span>
            <TextField
              fullWidth
              value={props.billingcontact.firstName}
              InputProps={{ readOnly: true }}
              variant="outlined"
            />
          </Grid>
          <Grid item md={6} sm={6} xs={6}>
            <span>Last Name</span>
            <TextField
              fullWidth
              value={props.billingcontact.lastName}
              InputProps={{ readOnly: true }}
              variant="outlined"
            />
          </Grid>

          <Grid item md={6} sm={6} xs={6}>
            <span>Mobile</span>
            <TextField
              fullWidth
              value={props.billingcontact.mobile}
              InputProps={{ readOnly: true }}
              variant="outlined"
            />
          </Grid>

          <Grid item md={6} sm={6} xs={6}>
            <span>Fax</span>
            <TextField
              fullWidth
              value={props.billingcontact.fax}
              InputProps={{ readOnly: true }}
              variant="outlined"
            />
          </Grid>

          <Grid item md={8} sm={8} xs={8}>
            <span>Phone</span>
            <TextField
              fullWidth
              value={props.billingcontact.phone}
              InputProps={{ readOnly: true }}
              variant="outlined"
            />
          </Grid>

          <Grid item md={4} sm={4} xs={4}>
            <span>PhoneExtension</span>
            <TextField
              value={props.billingcontact.phoneExtension}
              fullWidth
              InputProps={{ readOnly: true }}
              variant="outlined"
            />
          </Grid>
        </Grid>
      </div>
    )
  }

  const BillingAddress = () => {
    return (
      <>
        <div className="approvalpage_formcontainer_fieldstyle">
          <Grid container rowSpacing={2} columnSpacing={2}>
            <Grid item md={12} sm={12} xs={12}>
              <span>Company Name</span>
              <TextField
                fullWidth
                value={props?.billingaddress.companyName}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
              <span>Address Line 1</span>
              <TextField
                fullWidth
                value={props?.billingaddress.line1}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
              <span>Line2</span>
              <TextField
                fullWidth
                value={props?.billingaddress.line2}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
              <span>City</span>
              <TextField
                fullWidth
                value={props?.billingaddress.city}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
              <span>State</span>
              <TextField
                fullWidth
                value={props?.billingaddress.state}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
              <span>Country</span>
              <TextField
                fullWidth
                value={props?.billingaddress.country}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
              <span>Zip</span>
              <TextField
                fullWidth
                value={props?.billingaddress.zip}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </div>
      </>
    )
  }

  const CreditCardForm = ({ creditcard }) => (
  <Grid container>
    <Grid item md={12}>
      <Box className="stepper-border-style stepper-main-contianer1 stepper-box-shadow-style">
        <Box className="stepper-payemnt-container-1">
          <Box className="stepper-payemnt-contianer-2">
            <span />
            <span>
              <img src={visalogo} alt="visa" width="50" />
              &emsp;
              <img src={mastercardlogo} alt="master" width="50" />
              &emsp;
              <img src={americanexpresslogo} alt="ame" width="50" />
            </span>
          </Box>
        </Box>
        <div style={{ padding: '20px' }}>
          <Grid container columnSpacing={2} rowSpacing={3}>
            <Grid item md={6} sm={6} xs={6}>
              <span>First Name</span>
              <TextField variant="outlined" fullWidth size="small" value={creditcard?.firstName ?? null} />
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
              <span>Last Name</span>
              <TextField fullWidth variant="outlined" size="small" value={creditcard?.lastName ?? null} />
            </Grid>
            <Grid item xs={12}>
              <span>Card Number</span>
              <TextField variant="outlined" fullWidth size="small" value={creditcard?.cardNumber ?? null} />
            </Grid>
            <Grid item md={4} sm={4} xs={4}>
              <span>Exp Month</span>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                value={creditcard?.expriationMonth == 0 ? 'XX' : creditcard?.expriationMonth ?? ''}
              />
            </Grid>
            <Grid item md={4} sm={4} xs={4}>
              <span>Exp Year</span>
              <TextField variant="outlined" fullWidth size="small" value="20XX" />
            </Grid>
            <Grid item xs={4}>
              <span>CVV</span>
              <TextField variant="outlined" fullWidth size="small" value={creditcard?.cvv ?? null} />
            </Grid>
          </Grid>
        </div>
      </Box>
    </Grid>
  </Grid>
)

const BankAccountForm = ({ bankAccount }) => (
  <Grid container>
    {[
      ['Account Name', bankAccount?.accountName],
      ['Account Number', bankAccount?.accountNumber],
      ['Routing Number', bankAccount?.routingNumber],
      ['Account Type', bankAccount?.accountType],
      ['Bank Name', bankAccount?.bankName],
      ['Cheque Number', bankAccount?.checkNumber],
    ].map(([label, value]) => (
      <Grid item md={12} sm={12} xs={12}>
        <span>{label}</span>
        <TextField fullWidth value={value ?? null} inputProps={{ readOnly: true }} />
      </Grid>
    ))}
  </Grid>
)

  const paymentForm = () => (
  <div className="approvalpage_formcontainer_fieldstyle">
    {props?.creditcard ? (
      <CreditCardForm creditcard={props.creditcard} />
    ) : (
      <BankAccountForm bankAccount={props?.paymentMethod?.bankAccount} />
    )}
  </div>
)

  const appearance = () => {
    return (
      <>
        <div className="approvalpage_formcontainer_fieldstyle">
          <div className="approvalpage_logo_container">
            {props?.logourl?.logoUrl ? (
              <>
                <img
                  src={props.logourl.logoUrl}
                  width="100%"
                  height="70px"
                  style={{ objectFit: 'contain' }}
                  alt="User logo"
                />
                <span>Logo</span>
              </>
            ) : (
              <span>No image</span>
            )}
          </div>
        </div>
      </>
    )
  }

  const billingForm = () => {
    const label = { inputProps: { 'aria-label': 'Switch demo' } }
    return (
      <>
        <div className="">
          <div className="approvalpage_billingtype_container">
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                value={props?.billingtype.billingType}
                name="radio-buttons-group"
              >
                <FormControlLabel
                  value="1"
                  control={<Radio disabled={true} />}
                  label={
                    <>
                      Altigen will bill you
                      <span
                        style={{
                          display: 'inline-flex',
                          verticalAlign: 'middle',
                          color: '#4682b4',
                        }}
                      >
                        {/*<HelpIcon />*/}
                      </span>
                    </>
                  }
                />
                <FormControlLabel
                  value="2"
                  control={<Radio disabled={true} />}
                  label={
                    <>
                      Altigen will bill your Resellers/Direct Customers
                      <span
                        style={{
                          display: 'inline-flex',
                          verticalAlign: 'middle',
                          color: '#4682b4',
                        }}
                      >
                        {/*<HelpIcon />*/}
                      </span>
                    </>
                  }
                />
              </RadioGroup>
            </FormControl>
          </div>
        </div>
      </>
    )
  }

  const [openremarks, setopenremarks] = useState(false)

  // reject function
  const rejectfunction = () => {
    setopenremarks(!openremarks)
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 2,
  }

  const handleClose = () => setopenremarks(false)
  const [remarkmessage, setremarkmessage] = useState('')
  const [remarkmessagehelpertext, setremarkhelpertext] = useState('')
 const rejectCompany = (status) => {
  setremarkhelpertext('')

  const isApprove = status == 'approve'
  const hasRemarks = remarkmessage !== ''

  if ((isApprove && !hasRemarks) || (!isApprove && hasRemarks)) {
    isApprove ? setapproveloader(true) : setrejectapproval(true)

    const token = localStorage.getItem('sd_cp.jwt:tkn')
    const decoded = jwt_decode(token)
      let currentcompanyId = searchParams.get('company_id')
      if (!currentcompanyId) {
        currentcompanyId = decoded?.company_id
      }
    const responseBody = {
      companyId: props?.spcompanyid,
      companyStatus: isApprove ? COMPANY_STATUS.Active : COMPANY_STATUS.Rejected,
      remarks: remarkmessage,
    }

    const config = { headers: { Authorization: `Bearer ${token}` } }

    const roleHandlers = {
      serviceprovider: () => serviceproviderapproval(responseBody, config),
      reseller: () => resellerapproval(responseBody, config),
      customer: () => customerapproval(responseBody, config),
    }

    roleHandlers[props?.role]?.() ?? null
  } else {
    setremarkhelpertext('Please enter remarks before rejection')
  }
}

  const serviceproviderapproval = async (responseBody, config) => {
    try {
      const data = await companyApproval(responseBody, config)
      setapproveloader(false)
      setrejectapproval(false)
      dispatch(setIsToggleServiceProvider(false))
      const index = state.serviceProvidersList?.findIndex(
        (o) => o.id === responseBody.companyId
      )
      const serviceProviders = [...state.serviceProvidersList]
      if (index != -1) {
        serviceProviders[index] = {
          ...serviceProviders[index],
          companyStatus: responseBody?.companyStatus,
        }
      }
      dispatch(setServiceProvidersList(serviceProviders))
      dispatch(setServiceProviderTrigger('triggered'))
      toast.showToast('Request success')
    } catch (error) {
      setapproveloader(false)
      setrejectapproval(false)
      toast.showToast(normalizeApiResponse(error)?.message, 'error')
    }
  }

  const resellerapproval = async (responseBody, config) => {
    try {
      const data = await approveorrejectreseller(responseBody, config)
      setapproveloader(false)
      setrejectapproval(false)
      dispatch(setIsToggleReseller(false))
      props?.showServiceProvider(true)
      const index = state.resellersList?.findIndex(
        (o) => o.id === responseBody.companyId
      )
      const resellers = [...state.resellersList]
      if (index != -1) {
        resellers[index] = {
          ...resellers[index],
          companyStatus: responseBody?.companyStatus,
        }
      }
      dispatch(setResellersList(resellers))
      dispatch(setResellerTrigger('triggered'))
      toast.showToast('Request success')
    } catch (error) {
      setapproveloader(false)
      setrejectapproval(false)
      toast.showToast(normalizeApiResponse(error)?.message, 'error')
    }
  }

  const customerapproval = async (responseBody, config) => {
    try {
      const data = await approveorrejectcustomer(responseBody, config)
      setapproveloader(false)
      setrejectapproval(false)
      const index = state.directCustomersList?.findIndex(
        (o) => o.id === responseBody?.companyId
      )
      const directCustomers = state.directCustomersList
        ? [...state.directCustomersList]
        : []
      if (index != -1) {
        directCustomers[index] = {
          ...directCustomers[index],
          companyStatus: responseBody?.companyStatus,
        }
      }
      props?.showServiceProvider(props?.isDirectCustomer)
      dispatch(setDirectCustomersList(directCustomers))
      dispatch(setIsToggleCustomer(false))
      if (props?.isDirectCustomer) {
        dispatch(setIsToggleServiceProvider(!props?.isDirectCustomer))
        dispatch(setServiceProviderTrigger('triggered'))
      }
      toast.showToast('Request success')
    } catch (error) {
      setapproveloader(false)
      setrejectapproval(false)
      toast.showToast(normalizeApiResponse(error)?.message, 'error')
    }
  }

  const approvefunction = () => {
    const status = 'approve'
    rejectCompany(status)
  }

  const toggleback = () => {
    if (props?.role == 'serviceprovider')
      dispatch(setIsToggleServiceProvider(false))
    if (props?.role == 'reseller') dispatch(setIsToggleReseller(false))
    if (props?.role == 'customer') {
      dispatch(setIsToggleCustomer(false))
      props?.showServiceProvider(props?.isCustomerApproval ? true : false)
    }
  }

  return (
    <>
      <Box sx={{ textAlign: 'right', paddingRight: '20px', my: '20px' }}>
        <Button onClick={toggleback} variant="outlined">
          {props?.role == 'serviceprovider' ? (
            <>
              <KeyboardBackspaceIcon /> &emsp; ServiceProvider List
            </>
          ) : props?.role == 'reseller' ? (
            <>
              <KeyboardBackspaceIcon /> &emsp; Reseller's List
            </>
          ) : props?.role == 'customer' ? (
            <>
              <KeyboardBackspaceIcon /> &emsp; Customer's List
            </>
          ) : null}
        </Button>
      </Box>

      <div className="approvalcompany_main_container">
        <ButtonGroup
          variant="contained"
          aria-label="outlined primary button group"
        >
          {(props?.fulldata?.directCustomer === true || (props?.fulldata?.directCustomer === false && props?.fulldata?.companyLevel === COMPANY_LEVELS.reseller)) && (
            <>
              <Button onClick={() => setapprovalfromType('accountdetails')}>
                Account Details
              </Button>
              <Button onClick={() => setapprovalfromType('companydetails')}>
                Company Details
              </Button>
              {(props?.fulldata?.companyLevel === COMPANY_LEVELS.customer || props?.fulldata?.companyLevel === COMPANY_LEVELS.reseller) && (
                <>
                  <Button onClick={() => setapprovalfromType('billingcontact')}>
                    billing Contact
                  </Button>
                  <Button onClick={() => setapprovalfromType('billinginfo')}>
                    billing Address
                  </Button>
                </>
              )}
              {props?.fulldata?.companyLevel ==
              COMPANY_LEVELS.serviceprovider ? (
                <Button onClick={() => setapprovalfromType('billingtype')}>
                  billing Type
                </Button>
              ) : (
                ''
              )}
              {props?.fulldata?.isAltigenBilling ? (
                <Button onClick={() => setapprovalfromType('paymentmethod')}>
                  payment Method
                </Button>
              ) : (
                ''
              )}
              <Button onClick={() => setapprovalfromType('appearance')}>
                Appearance
              </Button>{' '}
            </>
          )}

          {props?.fulldata?.directCustomer === false && props?.fulldata?.companyLevel == COMPANY_LEVELS.customer && (
            <>
              <Button onClick={() => setapprovalfromType('accountdetails')}>
                Account Details
              </Button>
              <Button onClick={() => setapprovalfromType('companydetails')}>
                Company Details
              </Button>
              <Button onClick={() => setapprovalfromType('appearance')}>
                Appearance
              </Button>{' '}
            </>
          )}
        </ButtonGroup>
        <div className="approvalpage_formcontainer">
          {approvalforms(approvalformType)}
          <div>
            {checkPermission(
              [props?.permissions],
              commonState.currentCompanyDetails,
              props?.level,
              props?.upperLevel
            ) ? (
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Button
                  variant="contained"
                  color="success"
                  sx={{ color: 'white' }}
                  onClick={approvefunction}
                >
                  Approve{' '}
                  {approveloader ? (
                    <>
                      {' '}
                      &emsp;{' '}
                      <CircularProgress sx={{ color: '#fff' }} size={20} />{' '}
                    </>
                  ) : null}{' '}
                </Button>{' '}
                &emsp;
                <Button
                  onClick={rejectfunction}
                  variant="contained"
                  color="error"
                >
                  Reject with remarks
                </Button>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>

      <Modal open={openremarks} onClose={handleClose}>
        <Box sx={style}>
          <TextField
            helperText={remarkmessagehelpertext}
            error={remarkmessagehelpertext != '' ? true : false}
            label="Remarks"
            onChange={(e) => setremarkmessage(e.target.value)}
            fullWidth
            multiline
            rows={6}
          />
          <Box sx={{ textAlign: 'center', pt: '5px' }}>
            <Button variant="contained" onClick={rejectCompany}>
              Reject{' '}
              {rejectloader ? (
                <>
                  {' '}
                  &emsp; <CircularProgress
                    sx={{ color: '#fff' }}
                    size={20}
                  />{' '}
                </>
              ) : null}{' '}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  )
}
